import React from 'react';
import Modal from './Modal';
import Button from './Button';
import { colors, typography, spacing } from '../../theme/tokens';

/**
 * ConfirmDialog — diálogo de confirmación. Normalmente no se usa directamente:
 * consumir vía useConfirm() para API imperativa.
 *
 * @param {boolean} open
 * @param {string} title
 * @param {string|React.ReactNode} message
 * @param {string} confirmLabel
 * @param {string} cancelLabel
 * @param {boolean} destructive
 * @param {() => void} onConfirm
 * @param {() => void} onCancel
 */
const ConfirmDialog = ({
  open,
  title = 'Confirmar',
  message,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  destructive = false,
  onConfirm,
  onCancel,
}) => {
  return (
    <Modal
      open={open}
      onClose={onCancel}
      title={title}
      size="sm"
      footer={
        <>
          <Button variant="ghost" onClick={onCancel}>{cancelLabel}</Button>
          <Button
            variant={destructive ? 'destructive' : 'primary'}
            onClick={onConfirm}
            autoFocus
          >
            {confirmLabel}
          </Button>
        </>
      }
    >
      <div
        style={{
          fontSize: typography.fontSize.base,
          color: colors.text,
          lineHeight: typography.lineHeight.normal,
          paddingTop: spacing[1],
        }}
      >
        {message}
      </div>
    </Modal>
  );
};

export default ConfirmDialog;
